<template>
  <div>
    <div class="row justify-content-center">
       <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>{{$t("real_estate")}}</span>
                </div>
            </div>
     
    </div>

    <div class="row" style="padding-left: 15px; padding-right: 15px;">
      <div class="col-6 offset-3">
        <div class="container form-background">
           <div class="row">
              <div
                class=" col-12 text-left form-title"
              >
                <span
                  class="row-table-font-margins"
                  
                  >{{ formTitle }}</span
                >
              </div>
            </div>
          
          <div class="row">
            <div class="col-md-6">
              <label>Name: *</label>
              <input type="text" v-model="name" placeholder="Name" class="form-control"/>
              <div v-show="submitted && !name" class="invalid-feedback">
                Expense type name is required
              </div>
            </div>
            <div class="col-md-6">
                <label>VAT Percentage: *</label>
                <input type="text" v-model="vatPercentage" placeholder="VAT Pecenteage" class="form-control" />
                
            </div>
          </div>

          

          

          <!-- <div v-if="!isPartOfComplex"
            class="form-group"
            style="padding-left: 15px; padding-right: 15px;"
          >
            <strong>Is Complex: </strong>
            <input
              type="checkbox"
              v-model="building.isComplex"
              class="form-check-input"
            />
          </div> -->

        

          <input type="hidden" name="user_id" value="user_id" />
        </div>
         <div class="text-right">
          <button type="submit" @click.prevent="saveExpenseType()" class="btn btn-submit" style="margin: 15px;">
            Submit
          </button>
          <button @click.prevent="$router.go(-1)" class="btn btn-cancel">Cancel</button>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
import { expenseTypeService } from "@/_services";
import { mapState } from "vuex";
import { redirectToBuildingList } from "@/_helpers/list-redirect";
export default {
  data: function () {
    return {
        name: "",
        vatPercentage: 0,
      id: 0,
      submitted: false,
      formTitle: "Add new expense type",
      submitOrUpdate: "Submit",
    //  buildingName: "",
    };
  },
  mounted() {
    if (redirectToBuildingList(this, "expensetypes")) return;
    this.buildingName = this.$route.params.buildingName;
    if (this.$route.params.id) {
      this.formTitle = "Update expense type";
      this.submitOrUpdate = "Update";
      this.id = this.$route.params.id;
      this.buildingId = this.$route.params.buildingId;
      this.getExpenseType();
    } else {
      this.buildingId = this.$route.params.buildingId;
    }
  },
  methods: {
    // cancel(){
    //      this.$router.push({name:'expensetypes',params:{buildingId: this.buildingId}})
    // },
    getExpenseType: function () {
      expenseTypeService.getById(this.id).then((response) => {
          (this.buildingId = response.buildingId),
              this.vatPercentage = response.vatPercentage,
          // this.buildingName = response.data.building.name,
          (this.name = response.name);
      });
    },
    saveExpenseType: function () {
      var canSubmit = this.name;
      if (this.id) {
        this.submitted = true;
        if (canSubmit)
          expenseTypeService
              .updateExpenseType(this.id, this.name, this.buildingId, this.vatPercentage)
            .then(
              () => {
                this.$router.push({
                  name: "expensetypes",
                    params:
                    {
                        buildingId: this.buildingId,

                    },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      } else {
        this.submitted = true;
        if (canSubmit)
            expenseTypeService.addExpenseType(this.name, this.buildingId, this.vatPercentage).then(
            () => {
              this.$router.push({
                name: "expensetypes",
                params: { buildingId: this.buildingId },
              });
            },
            () => {
              alert("error");
              //  this.infoError = true
              //  this.loader = false
              //   this.password = ''
            }
          );
      }
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
  },
  // Our Javascript logic
};
</script>
